// import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
// import URLstateContext from "../../../provider/CommonContext";
// import { format, parseISO } from 'date-fns';
// import LinearProgress from '@mui/material/LinearProgress';
// import {
//     GetPostMethodData,
//     DecryptAESdata,
// } from "../../../provider/ServiceProvider";
// import '../../Product/Product.css'
// import animation from '../../../images/jm-animation.gif';
// import { useNavigate } from "react-router-dom";
// import invester from '../../../images/Investor.png'
// import partner from '../../../images/partner.png'

// function SideCard(props) {
//     const [data, setData] = useState([]);
//     const [dataType, setDataType] = useState([]);
//     const [value, setValue] = useState('');
//     const [valueDrop, setValueDrop] = useState("");
//     let navigate = useNavigate();
//     const { BaseURL } = useContext(URLstateContext);
//     const [loadingshow, setloadingshow] = useState(false);
//     let getSchemeCode = props.SchemeCode;
//     const [toggle, setToggle] = useState(false)

//     useEffect(() => {
//         setloadingshow(true);
//         GetPostMethodData(BaseURL + "GetProductNAV", {
//             IVSchemeCode: getSchemeCode,
//         }).then((data) => {
//             setloadingshow(false);
//             if (data.data != null && data.data.length > 0) {
//                 setData(DecryptAESdata(data.data));

//                 setloadingshow(false);
//                 let dataNav = DecryptAESdata(data.data);
//                 let valueDrp = dataNav[0].SAR6Mon;
//                 if (valueDrp != null) {
//                     setValue('0')
//                 } else {
//                     setValue("1")
//                 }
//             }
//         });
//         GetPostMethodData(BaseURL + "GetProductSchemeType", {
//             IVSchemeCode: getSchemeCode,
//         }).then((data) => {
//             setloadingshow(false);
//             if (data.data != null && data.data.length > 0) {
//                 setDataType(DecryptAESdata(data.data));

//                 setloadingshow(false);
//             }
//         });
//     }, [BaseURL]);

//     const changeFundType = (event) => {
//         let codeType = event.target.value;
//         const schemeType = event.currentTarget.dataset.type;
//         const schemeName = event.currentTarget.dataset.name;
//         let schemeDesc = document.getElementById("fund");
//         let textScheme = schemeDesc.options[schemeDesc.selectedIndex].text;
//         window.open("/products/" + schemeType.replace(/ /g, '-').replace('&', 'and').replace('+', '') + "/" + schemeName.replace(/ /g, '-').replace('&', 'and').replace('+', '') + "/" + codeType + "/" + textScheme.replace(/ /g, '-').replace('&', 'and'), "_self");
//     }

//     const handleChange = () => {
//         let path = window.location;
//         navigate(path, { state: { plan: "performance" } });
//     }

//     const BtnInvest = () => {
//         // document.getElementById("myDropdown").style.display = "block";
//         var x = document.getElementById("invest");
//         if (x.style.display === "none") {
//             x.style.display = "block";
//         } else {
//             x.style.display = "none";
//         }
//     }

//     return (
//         <>
//             <div className="invest-card">
//                 <div className="card-headers">
//                     {data && data.map(({ FundName }) => (
//                         <h2>{FundName}</h2>
//                     ))}
//                     <div className="select-container">
//                         <select name="fund" id="fund" className="data-selector" onChange={changeFundType} data-type={(data[0] != undefined) ? data[0].categoryname : "-"} data-name={(data[0] != undefined) ? data[0].FundName : "-"}>
//                             {dataType && dataType.map(({ PlanDesc, SchemeCode }) => (
//                                 <>
//                                     <option value={SchemeCode} selected={getSchemeCode === SchemeCode}>{PlanDesc}</option>
//                                 </>
//                             ))}
//                         </select>
//                         <i className="fa fa-caret-down" aria-hidden="true"></i>
//                     </div>
//                     <span className="descSideCart">To View NAV for other plans/options, <a className="CursorPointer" href="/NAVs-and-IDCW/LatestNAV">click here.</a></span>
//                 </div>
//                 {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
//                 {loadingshow ? (
//                     <div className="textcentervertex HomeLoader">
//                         <img src={animation} alt="Loading" />
//                         <div className="model_popup">Please Wait...</div>
//                     </div>
//                 ) : (
//                     <div>
//                         {data.length === 0 ? (
//                             <h5 className="errormsgComNew">No Data Available</h5>
//                         ) : (
//                             <>
//                                 {data && data.map(({ FundName, BmName, SAR6Mon, riskimage, navdate, nav, PercentChange, CAGR1Yr, BmCAGR1Yr,
//                                     Bm1Name, Bm1CAGR1Yr, CAGR3Yr, BmCAGR3Yr, Bm1CAGR3Yr, CAGR5Yr, BmSAR6Mon, Bm1SAR6Mon, BmCAGR5Yr, Bm1CAGR5Yr, CAGRInception,
//                                     BmCAGRInception, Bm1CAGRInception, BmRiskImage, AsonDate }) => (
//                                     <>
//                                         {/* <p className="text-xsm mt-2">An open ended dynamic equity scheme investing across large cap, mid
//                              cap,
//                              small cap stocks</p> */}
//                                         <hr />
//                                         <div className="benchmark_card">
//                                             <p className="text-xsm">Benchmark Index</p>
//                                             <span className="text-sm text-700">{(BmName && BmName != null) ? BmName : "--"}</span>
//                                             {/* <span className="ml-2">
//                                  <img src={riskimage} alt="" />
//                              </span> */}
//                                             <span className='hover-img'>
//                                                 <img src={riskimage ? (riskimage) : "-"}></img>
//                                                 <img src={BmRiskImage ? (BmRiskImage) : "--"} alt="BmRiskImage" className='riskimage-hover-card' />
//                                             </span>
//                                         </div>
//                                         <div className="date-container">
//                                             <p className="text-xsm textNav">Nav as on {navdate ? (format(parseISO(navdate), 'do MMM, yyyy')) : "--"}</p>
//                                         </div>
//                                         <div className="amount-market">
//                                             <span className="text-700">₹ {nav ? (nav) : "--"}</span>
//                                             <span className={(PercentChange && PercentChange > 0) ? "text-green textAmount" : "text-red textAmount"}>
//                                                 {PercentChange} %
//                                             </span>
//                                         </div>
//                                         <div className="tab-container">
//                                             <ul>
//                                                 { <li className="active liSideCard">
//                                                     Lumpsum
//                                                 </li>}
//                                             </ul>
//                                             <div className="form-group">
//                                                 { <label for="" className="text-sm">For</label>}
//                                                 <div className="select-container selectCard">
//                                                     { <select name="fund" id="fund" className="data-selector" onChange={(event) => setValue(event.target.value)}>
//                                                         {(SAR6Mon && SAR6Mon != null) ? <option value="0">6 Months</option> : ''}
//                                                         { <option value="1">1 Year</option>}
//                                                         { <option value="2">3 Year</option>}
//                                                         { <option value="3">5 Year</option>}
//                                                         {<option value="4">Since Inception</option>}
//                                                     </select>}
//                                                     {<i className="fa fa-caret-down" aria-hidden="true"></i>}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="return-container">
//                                             {<span className="text-xsm textAnnual"><strong>CAGR Return :</strong>
//                                                 <p className="text-xsm">
//                                                     As on - {(AsonDate && AsonDate != null) ? (format(parseISO(AsonDate), 'do MMM, yyyy')) : '--'}
//                                                 </p>
//                                             </span>}
//                                         </div>
//                                         {( value === "0") ?
//                                             <div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     {data.CAGR1Yr && <div class="d-flex justify-content-between mb-1">
//                                                         {data.SAR6Mon && <p class="holding-progress-text pr-sm-4">This Fund</p>}
//                                                         <p class="holding-progress-text percentHolding">{(SAR6Mon && SAR6Mon != null) ? SAR6Mon.toFixed(1) : '-'}%</p>
//                                                     </div>}
//                                                     <LinearProgress variant="determinate" value={SAR6Mon ? (SAR6Mon) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(BmName && BmName != null) ? BmName : '--'}
//                                                             <span className="hover-text">Benchmark</span>
//                                                         </p>
//                                                         <p class="holding-progress-text percentHolding">{(BmSAR6Mon && BmSAR6Mon != null) ? BmSAR6Mon.toFixed(1) : '-'}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmSAR6Mon ? (BmSAR6Mon) : "-- "} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct" id="side-menu">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(Bm1Name && Bm1Name != null) ? Bm1Name : '--'}
//                                                             <span className="hover-text">Additional Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(Bm1SAR6Mon && Bm1SAR6Mon != null) ? Bm1SAR6Mon.toFixed(1) : '-'}%
//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={Bm1SAR6Mon ? (Bm1SAR6Mon) : "--"} />
//                                                 </div>
//                                             </div> : ''}
//                                         {(value === "1") ?
//                                             <>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4">This Fund</p>
//                                                         <p class="holding-progress-text percentHolding">{(CAGR1Yr && CAGR1Yr != null) ? CAGR1Yr.toFixed(1) : '-'}%</p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={CAGR1Yr ? (CAGR1Yr) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(BmName && BmName != null) ? BmName : '--'}
//                                                             <span className="hover-text">Benchmark</span>
//                                                         </p>
//                                                         <p class="holding-progress-text percentHolding">{(BmCAGR1Yr && BmCAGR1Yr != null) ? BmCAGR1Yr.toFixed(1) : '--'}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmCAGR1Yr ? (Bm1CAGR1Yr) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct" id="side-menu">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(Bm1Name && Bm1Name != null) ? Bm1Name : '--'}
//                                                             <span className="hover-text">Additional Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(Bm1CAGR1Yr && Bm1CAGR1Yr != null) ? Bm1CAGR1Yr.toFixed(1) : '-'}%
//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmCAGR1Yr ? (Bm1CAGR1Yr) : "--"} />
//                                                 </div></> : ''}
//                                         {(value === "2") ?
//                                             <><div className="img-container procuct-card-img barProduct">
//                                                 <div class="d-flex justify-content-between mb-1">
//                                                     <p class="holding-progress-text pr-sm-4">This Fund</p>
//                                                     <p class="holding-progress-text percentHolding">{(CAGR3Yr && CAGR3Yr != null) ? CAGR3Yr.toFixed(1) : '-'}%</p>
//                                                 </div>
//                                                 <LinearProgress variant="determinate" value={CAGR3Yr ? (CAGR3Yr) : "--"} />
//                                             </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(BmName && BmName != null) ? BmName : '--'}
//                                                             <span className="hover-text">Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(BmCAGR3Yr && BmCAGR3Yr != null) ? BmCAGR3Yr.toFixed(1) : '-'}%
//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmCAGR3Yr ? (BmCAGR3Yr) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4 cursor-pointer">{(Bm1Name && Bm1Name != null) ? Bm1Name : '--'}
//                                                             <span className="hover-text">Additional Benchmark</span>
//                                                         </p>
//                                                         <p class="holding-progress-text percentHolding">{(Bm1CAGR3Yr && Bm1CAGR3Yr != null) ? Bm1CAGR3Yr.toFixed(1) : '-- '}%
//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={Bm1CAGR3Yr ? (Bm1CAGR3Yr) : "--"} />
//                                                 </div></> : ""}
//                                         {(value === "3") ?
//                                             <><div className="img-container procuct-card-img barProduct">
//                                                 <div class="d-flex justify-content-between mb-1">
//                                                     <p class="holding-progress-text pr-sm-4">This Fund</p>
//                                                     <p class="holding-progress-text percentHolding">{(CAGR5Yr && CAGR5Yr != null) ? CAGR5Yr.toFixed(1) : '-'}%</p>
//                                                 </div>
//                                                 <LinearProgress variant="determinate" value={CAGR5Yr ? (CAGR5Yr) : "--"} />
//                                             </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4">{(BmName && BmName != null) ? BmName : '--'}
//                                                             <span className="hover-text">Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(BmCAGR5Yr && BmCAGR5Yr != null) ? BmCAGR5Yr.toFixed(1) : '-'}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmCAGR5Yr ? (BmCAGR5Yr) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4">{(Bm1Name && Bm1Name != null) ? Bm1Name : '--'}
//                                                             <span className="hover-text">Additional Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(Bm1CAGR5Yr && Bm1CAGR5Yr != null) ? Bm1CAGR5Yr.toFixed(1) : "-"}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={Bm1CAGR5Yr ? (Bm1CAGR5Yr) : "--"} />
//                                                 </div></> : ""}
//                                         {(value === "4") ?
//                                             <><div className="img-container procuct-card-img barProduct">
//                                                 <div class="d-flex justify-content-between mb-1">
//                                                     <p class="holding-progress-text pr-sm-4">This Fund</p>
//                                                     <p class="holding-progress-text percentHolding">{(CAGRInception && CAGRInception != null) ? CAGRInception.toFixed(1) : '-'}%</p>
//                                                 </div>
//                                                 <LinearProgress variant="determinate" value={CAGRInception ? (CAGRInception) : "--"} />
//                                             </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4">{(BmName && BmName != null) ? BmName : '--'}
//                                                             <span className="hover-text">Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(BmCAGRInception && BmCAGRInception != null) ? BmCAGRInception.toFixed(1) : '-'}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={BmCAGRInception ? (BmCAGRInception) : "--"} />
//                                                 </div>
//                                                 <div className="img-container procuct-card-img barProduct">
//                                                     <div class="d-flex justify-content-between mb-1">
//                                                         <p class="holding-progress-text pr-sm-4">{(Bm1Name && Bm1Name != null) ? Bm1Name : '--'}
//                                                             <span className="hover-text">Additional Benchmark</span></p>
//                                                         <p class="holding-progress-text percentHolding">{(Bm1CAGRInception && Bm1CAGRInception != null) ? Bm1CAGRInception.toFixed(1) : '-'}%

//                                                         </p>
//                                                     </div>
//                                                     <LinearProgress variant="determinate" value={Bm1CAGRInception ? (Bm1CAGRInception) : "--"} />
//                                                 </div></> : ""}
//                                         {/* <div className="ppl-invested">
//                     <div className="img-container">
//                         <img src={product_ppl} alt="" />
//                     </div>
//                     <div className="content">
//                         <p>50.95k People have invested</p>
//                         <p>in this fund as on 23rd May 2023</p>
//                     </div>

//                         <a className="performance-side" onClick={handleChange}>View Performance Details</a>

//                         {/* <div className="btn-container"> */}
//                                         {/* <button className="bttn" onClick={BtnInvest}>INVEST
//                         </button> */}

//                                         <button
//                                             onClick={() => setToggle(!toggle)}
//                                             class="bttn">
//                                             INVEST
//                                         </button>
//                                         {toggle && (
//                                             <div className="invest-link-sidecard">
//                                                 <ul class="list-group">
//                                                     <li><img src={invester} alt="invester" /><a href='https://investor.jmfinancialmf.com/jmfinvestor/' target='_blank'>Investor</a></li>
//                                                     <li><img src={partner} alt="partner" /><a href='https://dit.jmfinancialmf.com/portal/login' target='_blank'>Partner</a></li>
//                                                 </ul>
//                                             </div>
//                                         )}
//                                         {/* <div className="persocial-icons-perspective invest-link" id="invest">

//                             <ul className='' id="invest">
//                                 <li><img src={invester} alt="invester" /><a href='https://investor.jmfinancialmf.com/jmfinvestor/' target='_blank'>Investor</a></li>
//                                 <li><img src={partner} alt="partner" /><a href='https://dit.jmfinancialmf.com/portal/login' target='_blank'>Partner</a></li>

//                             </ul>
//                         </div> */}
//                                     </>
//                                 ))}
//                             </>
//                         )}
//                     </div>

//                 )}
//                 {/* {loadingshow ? <div className="textcentervertex">
//                     <img src={animation} alt="Loading" />
//                     <div className="model_popup">Please Wait...</div>
//                 </div> : ""
//                 } */}
//             </div>

//         </>
//     )
// }

// export default SideCard

import React, { useState, useEffect, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { format, parseISO } from "date-fns";
import LinearProgress from "@mui/material/LinearProgress";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import "../../Product/Product.css";
import animation from "../../../images/jm-animation.gif";
import { useNavigate } from "react-router-dom";
import invester from "../../../images/Investor.png";
import partner from "../../../images/partner.png";
import { FiExternalLink } from "react-icons/fi";

function SideCard(props) {
  const [data, setData] = useState([]);
  const [dataType, setDataType] = useState([]);
  const [value, setValue] = useState("");
  const [valueDrop, setValueDrop] = useState("");
  let navigate = useNavigate();
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeCode = props.SchemeCode;
  let getFundCode = props.FundCode;
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetProductNAV", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
        let dataNav = DecryptAESdata(data.data);
        let valueDrp = dataNav &&  dataNav[0]?.SAR6Mon;
        if (valueDrp != null) {
          setValue("6");
        } else {
          setValue("1");
        }
      }
    });
    GetPostMethodData(BaseURL + "GetProductSchemeType", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataType(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);

  const changeFundType = (event) => {
    let codeType = event.target.value;
    const schemeType = event.currentTarget.dataset.type;
    const schemeName = event.currentTarget.dataset.name;
    let schemeDesc = document.getElementById("fund");
    let textScheme = schemeDesc.options[schemeDesc.selectedIndex].text;
    // alert(textScheme)
    window.open(
      "/products/" +
        schemeType.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeName.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        codeType +
        "/" +
        textScheme.replace(/ /g, "-").replace("&", "and"),
      "_self",
    );
  };

  const handleChange = () => {
    let path = window.location;
    navigate(path, { state: { plan: "performance" } });
  };

  const BtnInvest = () => {
    var x = document.getElementById("invest");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };

  return (
    <>
      <div className="invest-card">
        <div className="card-headers">
          {Array.isArray(data) &&
             data.map(({ FundName }) => <h2 key={FundName}>{FundName}</h2>)}
          {dataType && dataType.length > 0 && (
            <div className="select-container">
              <label
                htmlFor={`sidecard-fund-select-${getSchemeCode}`}
                className="sr-only"
              >
                Select plan for {data?.[0]?.FundName}
              </label>

              {/* <select
                name={`SelectedFundCode-${getSchemeCode}`}
                id={`sidecard-fund-select-${getSchemeCode}`}
                className={`data-selector fund-${getSchemeCode}`}
                autoComplete="off"
                onChange={changeFundType}
                data-type={
                  data && data[0] != undefined
                    ? data && data[0]?.categoryname
                    : "-"
                }
                data-name={
                  data && data[0] != undefined ? data && data[0]?.FundName : "-"
                }
              >
                {dataType &&
                  dataType.map(({ PlanDesc, SchemeCode }) => (
                    <option
                      key={SchemeCode}
                      value={SchemeCode}
                      selected={getSchemeCode === SchemeCode}
                    >
                      {PlanDesc}
                    </option>
                  ))}
              </select> */}
               <select
                name="fund"
                id="fund"
                className="data-selector"
                onChange={changeFundType}
                data-type={
                  data && data[0] != undefined
                    ? data && data[0]?.categoryname
                    : "-"
                }
                data-name={
                  data && data[0] != undefined ? data && data[0]?.FundName : "-"
                }
              >
                {dataType &&
                  dataType.map(({ PlanDesc, SchemeCode }) => (
                    <option
                      key={SchemeCode}
                      value={SchemeCode}
                      selected={getSchemeCode === SchemeCode}
                    >
                      {PlanDesc}
                    </option>
                  ))}
              </select>
              <i className="fa fa-caret-down"></i>
            </div>
          )}
          <span className="descSideCart">
            To View NAV for other plans/options,{" "}
            <a
              className="CursorPointer"
              href="/NAVs-and-IDCW/LatestNAV"
              aria-label="View latest NAVs for other plans and options"
            >
                <i class="fa fa-external-link" style={{color: "#013c66"}}></i>
            </a>
          </span>
        </div>
        {loadingshow ? (
          <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
            <img src={animation} alt="" aria-hidden="true" />
            <div className="model_popup">Please Wait...</div>
          </div>
        ) : (
          <div>
            {data && data.length === 0 ? (
              <h5 className="errormsgComNew" role="alert">No Data Available</h5>
            ) : (
              <>
                {Array.isArray(data) &&
                  data.map(
                    ({
                      FundName,
                      BmName,
                      SAR6Mon,
                      SAR3Mon,
                      SAR30D,
                      SAR15D,
                      SAR7D,
                      riskimage,
                      navdate,
                      nav,
                      PercentChange,
                      CAGR1Yr,
                      BmCAGR1Yr,
                      Bm1Name,
                      BmSAR3Mon,
                      Bm1CAGR1Yr,
                      CAGR3Yr,
                      BmCAGR3Yr,
                      Bm1CAGR3Yr,
                      CAGR5Yr,
                      CAGR10Yr,
                      BmSAR7D,
                      BmCAGR10Yr,
                      Bm1SAR3Mon,
                      BmSAR15D,
                      BmSAR30D,
                      BmSAR6Mon,
                      Bm1SAR6Mon,
                      Bm1SAR30D,
                      Bm1SAR15D,
                      Bm1SAR7D,
                      BmCAGR5Yr,
                      Bm1CAGR5Yr,
                      Bm1CAGR10Yr,
                      CAGRInception,
                      BmCAGRInception,
                      Bm1CAGRInception,
                      BmRiskImage,
                      AsonDate,
                      ProductVideoURL,
                    }) => (
                      // {SchemeRiskometerText, BenchmarkRiskometerText}
                      <div key={FundName}>
                        <hr />
                        <div className="benchmark_card">
                          <p className="text-xsm">Benchmark Index</p>
                          <span className="text-sm text-700">
                            {BmName || "--"}
                          </span>
                          <span className="hover-img">
                            <img
                              src={riskimage || "-"}
                              alt={`${BmName}  risk Indicator`}
                            />
                            <img
                              src={BmRiskImage || "--"}
                              alt={`${BmName} benchmark risk Indicator`}
                              className="riskimage-hover-card"
                            />
                          </span>
                        </div>
                        <div className="date-container">
                          <p className="text-xsm textNav">
                            Nav as on{" "}
                            {navdate
                              ? format(parseISO(navdate), "do MMM, yyyy")
                              : "--"}
                          </p>
                        </div>
                        <div className="amount-market">
                          <span className="text-700">
                            ₹{" "}
                            <span className="text-700">
                              {nav !== null && nav !== undefined
                                ? Number(nav).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                  })
                                : "--"}
                            </span>
                          </span>
                          <span
                            className={
                              PercentChange && PercentChange > 0
                                ? "text-green textAmount"
                                : "text-red textAmount"
                            }
                          >
                            {/* {PercentChange} % */}
                            {PercentChange !== null &&
                            PercentChange !== undefined &&
                            PercentChange !== ""
                              ? `${PercentChange} %`
                              : "-%"}
                          </span>
                        </div>
                        {CAGR1Yr && (
                          <>
                            <div className="tab-container">
                              <ul>
                                <li className="active liSideCard">Lumpsum</li>
                              </ul>
                              <div className="form-group">
                                <label htmlFor={`fund-${getSchemeCode}`} className="text-sm">
                                  For
                                   <span className="sr-only"> - Select time period</span>
                                </label>
                                <div className="select-container selectCard">
                                  <select
                                    name="fund"
                                    id={`fund-${getSchemeCode}`}
                                    className="data-selector"
                                    autoComplete="off"
                                    onChange={(event) =>
                                      setValue(event.target.value)
                                    }
                                  >
                                    {SAR7D && <option value="6">7 Days</option>}
                                    {SAR15D && (
                                      <option value="7">15 Days</option>
                                    )}
                                    {SAR30D && (
                                      <option value="8">1 Month</option>
                                    )}
                                    {SAR3Mon && (
                                      <option value="9">3 Months</option>
                                    )}
                                    {SAR6Mon && (
                                      <option value="0">6 Months</option>
                                    )}
                                    <option value="1">1 Year</option>
                                    <option value="2">3 Year</option>
                                    <option value="3">5 Year</option>
                                    <option value="5">10 Year</option>
                                    <option value="4">Since Inception</option>
                                  </select>
                                  <i className="fa fa-caret-down"></i>
                                </div>
                              </div>
                            </div>
                            <div className="return-container">
                              <span className="text-xsm textAnnual">
                                <strong>CAGR Return :</strong>
                                <p className="text-xsm">
                                  As on -{" "}
                                  {AsonDate
                                    ? format(parseISO(AsonDate), "do MMM, yyyy")
                                    : "--"}
                                </p>
                              </span>
                            </div>
                            {value === "6" && (
                              <div>
                                {!SAR7D && !BmSAR7D && !Bm1SAR7D ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "6"
                                          ? "7 Days"
                                          : value === "3"
                                            ? "5 years"
                                            : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {SAR7D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {SAR7D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={SAR7D}
                                          aria-label="7 Days SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmSAR7D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmSAR7D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmSAR7D}
                                          aria-label="7 Days BmSAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1SAR7D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1SAR7D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1SAR7D}
                                          aria-label="7 Days Bm1SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}
                            {value === "7" && (
                              <div>
                                {!SAR15D && !BmSAR15D && !Bm1SAR15D ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "7"
                                        ? "15 Days"
                                        : value === "2"
                                          ? "3 years"
                                          : value === "3"
                                            ? "5 years"
                                            : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {SAR15D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {SAR15D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={SAR15D}
                                          aria-label="15 Days SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmSAR15D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmSAR15D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmSAR15D}
                                          aria-label="15 Days BmSAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1SAR15D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1SAR15D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1SAR15D}
                                          aria-label="15 Days Bm1SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "8" && (
                              <div>
                                {!SAR30D && !BmSAR30D && !Bm1SAR30D ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "8"
                                        ? "30 Days"
                                        : value === "2"
                                          ? "3 years"
                                          : value === "3"
                                            ? "5 years"
                                            : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {SAR30D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {SAR30D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={SAR30D || 0}
                                          aria-label="30 Days SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmSAR30D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmSAR30D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmSAR30D || 0}
                                          aria-label="30 Days BmSAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1SAR30D ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1SAR30D.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1SAR30D || 0}
                                          aria-label="30 Days Bm1SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "9" && (
                              <div>
                                {!SAR3Mon && !BmSAR3Mon && !Bm1SAR3Mon ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "9"
                                          ? "3 Month"
                                          : value === "3"
                                            ? "5 years"
                                            : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {SAR3Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {SAR3Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={SAR3Mon || 0}
                                          aria-label="3 Month SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmSAR3Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmSAR3Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmSAR3Mon || 0}
                                          aria-label="3 Month BmSAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1SAR3Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1SAR3Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1SAR3Mon || 0}
                                          aria-label="3 Month Bm1SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "0" && (
                              <div>
                                {!SAR6Mon && !BmSAR6Mon && !Bm1SAR6Mon ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "0"
                                          ? "6 Month"
                                          : value === "3"
                                            ? "5 years"
                                            : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {SAR6Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {SAR6Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={SAR6Mon || 0}
                                          aria-label="6 Month SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmSAR6Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmSAR6Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmSAR6Mon || 0}
                                          aria-label="6 Month BmSAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1SAR6Mon ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1SAR6Mon.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1SAR6Mon || 0}
                                          aria-label="6 Month Bm1SAR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "1" && (
                              <div>
                                {!CAGR1Yr && !BmCAGR1Yr && !Bm1CAGR1Yr ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "3"
                                          ? "5 years"
                                          : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {CAGR1Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {CAGR1Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={CAGR1Yr}
                                          aria-label="1 Year CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmCAGR1Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmCAGR1Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmCAGR1Yr}
                                          aria-label="1 Year BmCAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1CAGR1Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1CAGR1Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1CAGR1Yr}
                                          aria-label="1 Year Bm1CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {/* {value === "2" && (
                                                    <div>
                                                        <div className="img-container procuct-card-img barProduct">
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <p className="holding-progress-text pr-sm-4">This Fund</p>
                                                                <p className="holding-progress-text percentHolding">{CAGR3Yr?.toFixed(1) || 'prakash'}%</p>
                                                            </div>
                                                            <LinearProgress variant="determinate" value={CAGR3Yr || 0} />
                                                        </div>
                                                        <div className="img-container procuct-card-img barProduct">
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <p className="holding-progress-text pr-sm-4 cursor-pointer">{BmName || '--'}
                                                                    <span className="hover-text">Benchmark</span>
                                                                </p>
                                                                <p className="holding-progress-text percentHolding">{BmCAGR3Yr?.toFixed(1) || 'Jay'}%</p>
                                                            </div>
                                                            <LinearProgress variant="determinate" value={BmCAGR3Yr || 0} />
                                                        </div>
                                                        {Bm1CAGR3Yr && (
                                                            <div className="img-container procuct-card-img barProduct">
                                                                <div className="d-flex justify-content-between mb-1">
                                                                    <p className="holding-progress-text pr-sm-4 cursor-pointer">{Bm1Name || '--'}
                                                                        <span className="hover-text">Additional Benchmark</span>
                                                                    </p>
                                                                    <p className="holding-progress-text percentHolding">{Bm1CAGR3Yr?.toFixed(1) || ''}%</p>
                                                                </div>
                                                                <LinearProgress variant="determinate" value={Bm1CAGR3Yr || 0} />
                                                            </div>
                                                        )}
                                                    </div>
                                                )} */}
                            {value === "2" && (
                              <div>
                                {!CAGR3Yr && !BmCAGR3Yr && !Bm1CAGR3Yr ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "3"
                                          ? "5 years"
                                          : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {CAGR3Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {CAGR3Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={CAGR3Yr}
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmCAGR3Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmCAGR3Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmCAGR3Yr}
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1CAGR3Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1CAGR3Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1CAGR3Yr}
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "3" && (
                              <div>
                                {!CAGR5Yr && !BmCAGR5Yr && !Bm1CAGR5Yr ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "3"
                                          ? "5 years"
                                          : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {CAGR5Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {CAGR5Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={CAGR5Yr}
                                          aria-label="5 year CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {BmCAGR5Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}{" "}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmCAGR5Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmCAGR5Yr}
                                          aria-label="5 year BmCAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {Bm1CAGR5Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}{" "}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1CAGR5Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1CAGR5Yr}
                                          aria-label="5 year BM1CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "5" && (
                              <div>
                                {!CAGR10Yr && !BmCAGR10Yr && !Bm1CAGR10Yr ? (
                                  <p className="returns">
                                    Since the scheme has not completed{" "}
                                    {value === "1"
                                      ? "1 year"
                                      : value === "2"
                                        ? "3 years"
                                        : value === "3"
                                          ? "5 years"
                                          : "10 years"}{" "}
                                    from the date of inception, the data is not
                                    available.
                                  </p>
                                ) : (
                                  <>
                                    {/* This Fund */}
                                    {CAGR10Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4">
                                            This Fund
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {CAGR10Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={CAGR10Yr}
                                          aria-label="10 year CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Benchmark */}
                                    {BmCAGR10Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {BmName || "--"}
                                            <span className="hover-text">
                                              Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {BmCAGR10Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={BmCAGR10Yr}
                                          aria-label="10 year BmCAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}

                                    {/* Additional Benchmark */}
                                    {Bm1CAGR10Yr ? (
                                      <div className="img-container procuct-card-img barProduct">
                                        <div className="d-flex justify-content-between mb-1">
                                          <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                            {Bm1Name || "--"}
                                            <span className="hover-text">
                                              Additional Benchmark
                                            </span>
                                          </p>
                                          <p className="holding-progress-text percentHolding">
                                            {Bm1CAGR10Yr.toFixed(1)}%
                                          </p>
                                        </div>
                                        <LinearProgress
                                          variant="determinate"
                                          value={Bm1CAGR10Yr}
                                          aria-label="10 year Bm1CAGR performance of this fund"
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            )}

                            {value === "4" && (
                              <div>
                                <div className="img-container procuct-card-img barProduct">
                                  <div className="d-flex justify-content-between mb-1">
                                    <p className="holding-progress-text pr-sm-4">
                                      This Fund
                                    </p>
                                    <p className="holding-progress-text percentHolding">
                                      {CAGRInception?.toFixed(1) || "-"}%
                                    </p>
                                  </div>
                                  <LinearProgress
                                    variant="determinate"
                                    value={CAGRInception || 0}
                                    aria-label="CAGR Inception performance of this fund"
                                  />
                                </div>
                                <div className="img-container procuct-card-img barProduct">
                                  <div className="d-flex justify-content-between mb-1">
                                    <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                      {BmName || "--"}
                                      <span className="hover-text">
                                        Benchmark
                                      </span>
                                    </p>
                                    <p className="holding-progress-text percentHolding">
                                      {BmCAGRInception?.toFixed(1) || "-"}%
                                    </p>
                                  </div>
                                  <LinearProgress
                                    variant="determinate"
                                    value={BmCAGRInception || 0}
                                    aria-label="BmCAGR Inception performance of this fund"
                                  />
                                </div>
                                {Bm1CAGRInception && (
                                  <div className="img-container procuct-card-img barProduct">
                                    <div className="d-flex justify-content-between mb-1">
                                      <p className="holding-progress-text pr-sm-4 cursor-pointer">
                                        {Bm1Name || "--"}
                                        <span className="hover-text">
                                          Additional Benchmark
                                        </span>
                                      </p>
                                      <p className="holding-progress-text percentHolding">
                                        {Bm1CAGRInception?.toFixed(1) || "-"}%
                                      </p>
                                    </div>
                                    <LinearProgress
                                      variant="determinate"
                                      value={Bm1CAGRInception || 0}
                                      aria-label="Bm1CAGR Inception performance of this fund"
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                        {/* {ProductVideoURL && <button
                                            className="bttn"
                                            // style={{ marginTop: "5px", marginBottom: "5px", backgroundColor: "white", border: "1px solid red", color: "black" }}
                                            style={{ marginTop: "8px", marginBottom: "8px" }}
                                            onClick={() => window.open(ProductVideoURL, '_blank')}
                                        >
                                            VIEW PRODUCT VIDEO
                                        </button>} */}
                      </div>
                    ),
                  )}
              </>
            )}
          </div>
        )}

        <button onClick={() => setToggle(!toggle)} class="bttn">
          INVEST
        </button>
        {toggle && (
  <div className="invest-link-sidecard invest-link">
    <ul className="link-div-invest list-group ">
      <li>
        <a
          href="https://investor.jmfinancialmf.com/jmfinvestor/"
          target="_blank"
          rel="noreferrer"
          className="invest-option active"
        >
          Investor
        </a>
      </li>
      <li>
        <a
          href="https://dit.jmfinancialmf.com/portal/login"
          target="_blank"
          rel="noreferrer"
          className="invest-option"
        >
          Partner
        </a>
      </li>
    </ul>
  </div>
)}
      </div>
    </>
  );
}

export default SideCard;
